import { render } from "./AboutUs.vue?vue&type=template&id=29e21fe2&scoped=true&ts=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=29e21fe2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e21fe2"]])

export default __exports__